module.exports = __webpack_public_path__ + "static/media/03.8b3111eb.png";